namespace TabAurous.Purchase {
    export namespace RateFixingService {
        export const baseUrl = 'Purchase/RateFixing';

        export declare function Create(request: Serenity.SaveRequest<RateFixingRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<RateFixingRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<RateFixingRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<RateFixingRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetLineNo(request: Serenity.ServiceRequest, onSuccess?: (response: GetLineNoResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Purchase/RateFixing/Create",
            Update = "Purchase/RateFixing/Update",
            Delete = "Purchase/RateFixing/Delete",
            Retrieve = "Purchase/RateFixing/Retrieve",
            List = "Purchase/RateFixing/List",
            GetLineNo = "Purchase/RateFixing/GetLineNo"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'GetLineNo'
        ].forEach(x => {
            (<any>RateFixingService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
